"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTeamMembers = void 0;
/* eslint-disable @typescript-eslint/explicit-function-return-type */
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const error_handler_1 = require("@app/util/error-handler");
const is_defined_1 = require("@app/util/is-defined");
const react_1 = __importDefault(require("react"));
const stream_chat_react_1 = require("stream-chat-react");
const LIMIT = 100;
function useTeamMembers({ workspaceId, onError }) {
    const [teamMembers, setTeamMembers] = react_1.default.useState([]);
    const [isFetching, setIsFetching] = react_1.default.useState(true);
    const chatClient = (0, stream_chat_react_1.useChatContext)().client;
    react_1.default.useEffect(() => {
        let shouldRetry = true;
        void fetchMembers();
        async function fetchMembers() {
            try {
                setIsFetching(true);
                let teamUsers = [];
                let offset = 0;
                let hasMore = true;
                while (hasMore) {
                    if (!(0, is_defined_1.isValue)(workspaceId))
                        continue;
                    const response = await chatClient.queryUsers({
                        teams: {
                            $contains: workspaceId,
                        },
                    }, {}, { limit: LIMIT, offset });
                    teamUsers = [...teamUsers, ...response.users];
                    hasMore = response.users.length === LIMIT;
                    offset += LIMIT;
                }
                setTeamMembers(teamUsers
                    .map((u) => ({
                    id: u.id,
                    name: u.name || u.id,
                    email: u.name,
                    firstName: u.name,
                }))
                    .filter((u) => u.id !== chatClient.userID)
                    .sort((member1, member2) => {
                    if (!member1.name && !member2.name) {
                        return 0;
                    }
                    if (!member1.name) {
                        return 1;
                    }
                    if (!member2.name) {
                        return -1;
                    }
                    return member1.name.localeCompare(member2.name);
                }));
                setIsFetching(false);
            }
            catch (error) {
                if (shouldRetry) {
                    shouldRetry = false;
                    void fetchMembers();
                    return;
                }
                console.error('ChannelCreator queryUsers failed', { error });
                onError();
                (0, error_handler_1.processErrors)([], (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.error')));
                setIsFetching(false);
            }
        }
    }, [workspaceId]);
    return {
        teamMembers,
        isFetching,
    };
}
exports.useTeamMembers = useTeamMembers;
